import { Box, Skeleton } from '@mui/material'
import React from 'react'
import { useStyles } from './styles'

interface DataViewProps {
  title: string
  lifes: number
  missingData: number
  isLoading: boolean
}

const DataView: React.FC<DataViewProps> = ({ lifes, missingData, title, isLoading }) => {
  const classes = useStyles()

  if (isLoading) {
    return (
      <Box className={classes.root}>
        <h3>{title}</h3>
        <Box className={classes.container}>
          <Box className={classes.item}>
            <span>Vidas com Dados Faltantes</span>
            <Skeleton
              width={188}
              height={32}
            />
          </Box>

          <Box className={classes.item}>
            <span>Dados faltantes</span>
            <Skeleton
              width={188}
              height={32}
            />
          </Box>
        </Box>
      </Box>
    )
  }

  return (
    <Box className={classes.root}>
      <h3>{title}</h3>
      <Box className={classes.container}>
        <Box className={classes.item}>
          <span>Vidas com Dados Faltantes</span>
          <strong>{lifes}</strong>
        </Box>

        <Box className={classes.item}>
          <span>Dados faltantes</span>
          <strong>{missingData}</strong>
        </Box>
      </Box>
    </Box>
  )
}

export default DataView
